// @noflow
import { dualColorGradiant } from '../../constants';
import PropTypes from 'prop-types';
import * as React from 'react';

SVGDefinitions.propTypes = {
    bottomColor: PropTypes.string,
    topColor: PropTypes.string
};

export default function SVGDefinitions({ bottomColor, topColor }) {
    return (
        <defs>
            {bottomColor &&
                topColor && (
                    <linearGradient id={dualColorGradiant} x1="0%" x2="0%" y1="0%" y2="100%">
                        <stop offset="0%" stopColor={topColor} />
                        <stop offset="48%" stopColor={topColor} />
                        <stop offset="52%" stopColor={bottomColor} />
                        <stop offset="100%" stopColor={bottomColor} />
                    </linearGradient>
                )}
        </defs>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/svg-container/definitions/component.js